export default __webpack_public_path__ + "static/roadmap-4597ec4b7de9e0cab86bc228b707b04d.png";